import { Attachment } from '@sdk/attachments/types';
import {
  Announcement as APIAnnouncement,
  AnnouncementDetails as APIAnnouncementDetails,
} from '@sdk/announcements/types/apiTypes';
import { isImage, isVideo } from '@sdk/attachments/helpers/utils';

import { Announcement } from '@web/announcements/types/Announcement';

const isAnnouncementDetails = (
  announcement: APIAnnouncement | APIAnnouncementDetails
): announcement is APIAnnouncementDetails => 'readUserIds' in announcement;

export const getImportance = (mimetype: string): number => {
  if (isImage(mimetype)) return 0;

  if (isVideo(mimetype)) return 1;

  return Infinity;
};

export const sortAttachments = (attachements: Attachment[]): Attachment[] =>
  attachements.sort((a, b) => getImportance(a.mimetype) - getImportance(b.mimetype));

export const mapAnnouncement = (
  apiAnnouncement: APIAnnouncement | APIAnnouncementDetails
): Announcement => {
  // @INFO this will work after TS version is up-to-date
  // const hasDetails = isAnnouncementDetails(apiAnnouncement);

  let allIds = [];
  let readIds = [];
  if (isAnnouncementDetails(apiAnnouncement)) {
    const hasPersonaIds = apiAnnouncement.personaIds.length;
    allIds = hasPersonaIds
      ? apiAnnouncement.personaIds
      : apiAnnouncement.users.map((user) => user.id);
    readIds = apiAnnouncement.readUserIds;
  }

  return {
    attachments: sortAttachments(apiAnnouncement.attachments),
    attachmentsCount: apiAnnouncement.attachments.length,
    author: {
      avatar: apiAnnouncement.author.avatar,
      fullname: `${apiAnnouncement.author.name} ${apiAnnouncement.author.lastname}`,
      id: apiAnnouncement.author.id,
      lastname: apiAnnouncement.author.lastname,
      name: apiAnnouncement.author.name,
    },
    description: apiAnnouncement.content ?? '',
    id: apiAnnouncement.id,
    isDeleted: false,
    isRead: apiAnnouncement.read,
    postedAt: new Date(apiAnnouncement.posted),
    recipients: {
      allIds,
      read: apiAnnouncement.readCount,
      readIds,
      total: apiAnnouncement.recipientCount,
    },
    title: apiAnnouncement.title ?? '',
  };
};

export const mapAnnouncements = (apiAnnouncements: APIAnnouncement[]): Announcement[] =>
  apiAnnouncements.map(mapAnnouncement);
